export default __webpack_public_path__ + "MBOS Cashback-Aktion 2026 -Teilnahmebedingungen_v1.0.pdf";